import {
  DefaultEmptyState,
  type IDefaultEmptyStateProps,
} from 'shared/ui/EmptyState/variants/DefaultEmptyState/DefaultEmptyState'
import {
  type IPreviewEmptyStateProps,
  PreviewEmptyState,
} from 'shared/ui/EmptyState/variants/PreviewEmptyState/PreviewEmptyState'

export type IEmptyStateProps = IDefaultEmptyStateProps | IPreviewEmptyStateProps

export const EmptyState = (props: IEmptyStateProps) => {
  if ('variant' in props && props.variant === 'preview') {
    return <PreviewEmptyState {...props} />
  }

  return <DefaultEmptyState {...props} />
}
